import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import { Toaster } from '../ui/sonner';
import { Menu, AlertTriangle, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [impersonating, setImpersonating] = useState(null);

  useEffect(() => {
    const imp = localStorage.getItem('impersonating');
    if (imp) setImpersonating(JSON.parse(imp));
  }, []);

  const stopImpersonating = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/stop-impersonate`, {
        method: 'POST', headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem('access_token', data.access_token);
        localStorage.removeItem('impersonating');
        localStorage.removeItem('superadmin_token');
        toast.success(data.message);
        window.location.href = '/';
      }
    } catch (e) { toast.error('Errore nel tornare a Superadmin'); }
  };

  return (
    <div className="flex flex-col min-h-screen bg-slate-50">
      {/* Impersonation Banner */}
      {impersonating && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm" data-testid="impersonation-banner">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          <span>Stai operando come <strong>{impersonating.name}</strong> ({impersonating.email}) — ruolo: {impersonating.role}</span>
          <button onClick={stopImpersonating} className="ml-2 px-3 py-1 bg-white text-amber-700 rounded-lg text-xs font-semibold hover:bg-amber-50 transition flex items-center gap-1" data-testid="stop-impersonate-btn">
            <ArrowLeft className="w-3 h-3" /> Torna a Superadmin
          </button>
        </div>
      )}      {/* Mobile top bar */}
      <div className={`md:hidden fixed left-0 right-0 z-30 bg-white border-b border-slate-200/60 px-4 py-3 flex items-center gap-3 ${impersonating ? 'top-10' : 'top-0'}`}>
        <button
          onClick={() => setSidebarOpen(true)}
          className="p-2 rounded-lg hover:bg-slate-100 text-slate-600"
          data-testid="hamburger-menu"
        >
          <Menu className="w-5 h-5" />
        </button>
        <span className="font-semibold text-slate-800" style={{ fontFamily: 'Manrope' }}>VoiceBook</span>
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay md:hidden"
          onClick={() => setSidebarOpen(false)}
          data-testid="sidebar-overlay"
        />
      )}

      <div className="flex flex-1">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="main-content flex-1 flex flex-col">
          {/* Spacer for mobile top bar */}
          <div className="md:hidden h-14 shrink-0" />
          <div className="flex-1">
            {children}
          </div>
          {/* Footer Badge */}
          <div className="px-4 sm:px-8 py-4 text-center border-t border-slate-200/60 bg-white">
            <a 
              href="https://telcavoip.ai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-[11px] text-slate-400 hover:text-sky-500 transition-colors"
              data-testid="footer-badge"
            >
              Made with <span className="text-red-400">&hearts;</span> by <span className="font-semibold text-slate-500 hover:text-sky-500">TelcaVoIP.AI</span>
            </a>
          </div>
        </main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
